exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.td-container[data-v-79a93951] {\n    margin-top: 8px;\n}\n", ""]);
